import { HowItWorksVideo } from "./howItWorksVideo";
import styles from "./howItWorks.module.scss";
import ScanButton from "../common/scanButton/scanButton";
import ScanButtonBar from "../common/scanButton/scanButtonBar";

const steps = ["Scan", "Support", "Win"];

export function HowItWorks() {
  return (
    <>
      <div className={styles.container}>
        <section className={styles.howItWorks}>
          <h2>
            <span>SCAN.</span> <span>SUPPORT.</span> <span>WIN.</span>
          </h2>
          <p className={styles.copy}>
            Claim Calgary courts as Dinos territory and you could win big
          </p>
          <div className={styles.scanButtonWrapper}>
            <ScanButton />
          </div>
          <p className={styles.copyThin}>
            {/* To support the Dinos in this years Final 8 Basketball Tournament you
            can transform any backboard in the city into a billboard to hype our
            home team. */}
            Scan any backboard in Calgary to turn it into a billboard that hypes
            the Dinos as they host this year's Final 8 Basketball tournament.
          </p>
          <section className={styles.steps}>
            {steps.map((step, index) => (
              <div
                key={`step-${index + 1}`}
                index={`Step ${index + 1}`}
                className={[styles.step, styles[`flicker${index + 1}`]].filter(Boolean).join(" ")}
              >
                <p>{index + 1}</p>
                <p>{step}</p>
              </div>
            ))}
          </section>
        </section>
        <HowItWorksVideo />
        <p
          className={[styles.copyThin, styles.centered, styles.copyTop]
            .filter(Boolean)
            .join(" ")}
        >
          Scan a backboard to claim that court for the Dinos. Submit your pic and you could win tickets to the Final 8, Dinos merch, or other prizes.
        </p>
        {/* <p className={[styles.copyThin, styles.centered, styles.copyTop].filter(Boolean).join(" ")}>
          launch the site, snap a photo of a backboard, claim your court for the
          Dinos, and cheer them on in the Final 8.
        </p>
        <p className={[styles.copyThin, styles.centered].filter(Boolean).join(" ")}>
          Submit your photo FOR A CHANCE TO win a half court shot for $5k and
          other prizes.
        </p> */}
        <div className={styles.scanButtonWrapper}>
          <ScanButton inverted />
        </div>
      </div>
    </>
  );
}
